<script>
    export default {
        mounted() {
            window.document.title = '速电通-充值协议';
        }
    }
</script>

<template>
    <div class="container">
        <div class="title">速电通充值服务协议</div>
        <div class="notice">尊敬的用户，为保障您的合法权益，请您在对速电通进行充值前仔细阅读本协议，当您点击“立即充值”按钮后，即视为你已经阅读并理解本协议内容，并同意按本协议的规定参与充值。</div>
        <div class="small-title">1 充值说明</div>
        <div>1.1 速电通的充电服务具有不允许欠费校验，故您充电时建议预先充值10元及其以上金额人民币。充值方法可按充值步骤指示完成；</div>
        <div>1.2 速电通有权不定期对用户进行充值满额赠送等促销活动；</div>
        <div>1.3 速电通充值次数不设限制，单笔金额最大为999元；</div>
        <div class="small-title">2 充值余额说明</div>
        <div>2.1 充值余额构成</div>
        <div>充值余额是指您实际支付的充值本金加上速电通的返现金额构成的账户余额（人民币）。</div>
        <div>2.2 充值余额有效期</div>
        <div>充值及返现金额有效期为自充值日起至用完即止。</div>
        <div>2.3 充值余额使用规则</div>
        <div>无论是充值余额或是速电通的赠送都只能用于支付速电通的所有电费、服务费，不支持转移、转增、赠送，不支持提现；</div>
        <div>2.4 充值余额不足或者退款说明</div>
        <div>由于您的速电通账号充值余额不足，可能导致部分服务受到影响或者导致服务终止，由您自行承担责任，速电通对此不承担责任。</div>
        <div class="small-title">3 账号安全</div>
        <div>3.1 请您自行设置速电通账号的登陆信息和密码，并妥善保管。若您泄露了账号登陆信息和密码等，由此引起的账号被盗及该账户内充值余额被盗用等风险和损失应由您自行承担，您不得将此作为取消交易、拒绝付款的理由；</div>
        <div>3.2 如您发现速电通的账号被盗，请您及时联系速电通公司找回账号。</div>
        <div class="small-title">4 其他</div>
        <div>4.1 合理保护</div>
        <div>我们包含充值赠送在内的所有优惠推广活动仅面向正当、合法使用我们充电服务的用户。一旦您存在利用我们的规则漏洞进行任何形式的作弊行为，我们有权取消与作弊行为相关的账号的赠送金额，追回您作弊所得的不正当经济利益、关闭作弊账号或与您相关的所有账号，并保留取消您后续使用我们服务的权限，及依据严重程度追究您的法律责任。</div>
        <div>4.2 速电通有权在必要时变更本协议条款，您可以在速电通相关页面查阅最新版本的协议条款。本协议变更后，如果您继续使用速电通服务，即视为您接受变更后的协议。</div>
    </div>
</template>

<style scoped>
    .container {
        padding: 10px;
        color: #515a6e;
        font-size: 12px;
        overflow-y: auto;
    }

    .title {
        margin: 10px;
        color: #17233d;
        text-align: center;
        font-weight: 700;
        font-size: 16px;
    }

    .notice {
        text-indent: 2em;
    }

    .small-title {
        color: #17233d;
        text-align: left;
        font-weight: 500;
        font-size: 14px;
    }

    view {
        margin-top: 4px;
    }
</style>
